import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';

// ReactQuill forwards id to a wrapper div, not to the editable textbox.
export default function RichTextEditor({ id, labelledBy, error, ...props }) {
  const editor = useRef(null);
  useEffect(() => {
    const root = editor.current?.getEditor().root;
    if (!root) return;
    root.id = id;
    root.setAttribute('role', 'textbox');
    root.setAttribute('aria-multiline', 'true');
    root.setAttribute('aria-labelledby', labelledBy);
    root.setAttribute('aria-invalid', error ? 'true' : 'false');
    if (error) root.setAttribute('aria-describedby', `${id}-error`);
    else root.removeAttribute('aria-describedby');
  }, [id, labelledBy, error]);
  return <ReactQuill {...props} ref={editor} />;
}
